import axios from "axios";
import {refreshAccessToken} from "./api-user-service";

const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL + "/api/astrological-diary",
    headers: {
        "Content-Type": "application/json",
    },
});

instance.interceptors.request.use(
    (config: any) => {
        const token = getAccessToken();
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (err.response) {
            // Validation failed, ...
            if (err.response.status === 400 && err.response.data) {
                return Promise.reject(err.response.data);
            }
            // Access Token was expired
            if (
                err.response.status === 401 &&
                !originalConfig._retry &&
                getAccessToken() != null
            ) {
                originalConfig._retry = true;
                try {
                    const rs = await refreshAccessToken();
                    const { accessToken, refreshToken } = rs.data;
                    setRefreshToken(refreshToken);
                    setAccessToken(accessToken);
                    instance.defaults.headers.common["Authorization"] =
                        "Bearer " + accessToken;
                    return instance(originalConfig);
                } catch (_error: any) {
                    if (_error.response && _error.response.data) {
                        return Promise.reject(_error.response.data);
                    }
                    return Promise.reject(_error);
                }
            }
            if (err.response.status === 403 && err.response.data) {
                return Promise.reject(err.response.data);
            }
            if (err.response.status === 404) {
                if (axios.isAxiosError(err)) {
                    return Promise.reject(err.response.data);
                }
                return;
            }
        }
        return Promise.reject(err);
    }
);

export function setAccessToken(token: string) {
    window.localStorage.setItem("accessToken", token);
}

export function setRefreshToken(token: string) {
    window.localStorage.setItem("refreshToken", token);
}

export function getAccessToken(): null | string {
    const accessToken = window.localStorage.getItem("accessToken");
    return accessToken;
}

export function getrefreshToken(): null | string {
    const refreshToken = window.localStorage.getItem("refreshToken");
    return refreshToken;
}

export function getSelectedUser(): null | any {
    const selectedUserId = window.localStorage.getItem("selectedUser");
    return selectedUserId;
}

export function removeTokens() {
    window.localStorage.removeItem("accessToken");
    window.localStorage.removeItem("refreshToken");
}

const responseBody: any = (response: any) => response.data;

const request = {
    get: (url: string) => instance.get(url).then().then(responseBody),
    post: (url: string, body?: any) => instance.post(url, body).then().then(responseBody),
    delete: (url: string) => instance.delete(url).then().then(responseBody),
};

const Calendar = {
    GetDiary: (date: string) => request.get("/get-by-date?dateTime=" + date),
    AddDiary: (data: any) => request.post("/add", data),
    DeleteDiary: (id: number) => request.delete("/delete-by-id?id=" + id),
};

export async function GetDiaryAsync(date: string) {
    return await Calendar.GetDiary(date)
        .then((response) => {
            return {response};
        })
        .catch((error) => {
            return error.response;
        });
}

export async function AddDiaryAsync(data: any) {
    return await Calendar.AddDiary(data)
        .then((response) => {
            return {response};
        })
        .catch((error) => {
            return error.response;
        });
}

export async function DeleteDiaryAsync(id: number) {
    return await Calendar.DeleteDiary(id)
        .then((response) => {
            return {response};
        })
        .catch((error) => {
            return error.response;
        });
}